import { OrderDetailType } from '@schemas'

class OrderDetail {
	constructor({
		id = '',
		productId = '',
		quantity = 0,
		soldUsd = 0,
		productName = '',
		standardUsd = 0,
		seasonUsd = 0,
		seasonDiscountedUsd = 0,
		seasonActiveUsd = 0,
		deletedAt = '',
	} = {}) {
		this.id = id === null ? '' : id
		this.productId = productId === null ? '' : productId
		this.quantity = quantity === null ? 0 : quantity
		this.soldUsd = soldUsd === null ? 0 : soldUsd
		this.productName = productName === null ? '' : productName
		this.standardUsd = standardUsd === null ? 0 : standardUsd
		this.seasonUsd = seasonUsd === null ? 0 : seasonUsd
		this.seasonDiscountedUsd = seasonDiscountedUsd === null ? 0 : seasonDiscountedUsd
		this.seasonActiveUsd = seasonActiveUsd === null ? 0 : seasonActiveUsd
		this.deletedAt = deletedAt === null ? '' : deletedAt
	}

	id: string
	productId: string
	quantity: number
	soldUsd: number
	productName: string
	standardUsd: number
	seasonUsd: number
	seasonDiscountedUsd: number
	seasonActiveUsd: number
	deletedAt: string
}

class Order {
	constructor({
		id = '',
		seasonId = '',
		customerId = '',
		customerEmail = '',
		couponId = '',
		couponCode = '',
		couponDiscountUsd = 0,
		boxType = '',
		deliveryCompany = '',
		trackingNumber = '',
		shippingRateType = '',
		deliveryCompletedAt = '',
		receiverGivenName = '',
		receiverFamilyName = '',
		phoneCountryNumber = '',
		phoneNumber = '',
		address1 = '',
		address2 = '',
		city = '',
		state = '',
		stateIsoCode = '',
		zip = '',
		country = '',
		countryCode = '',
		totalUsd = 0,
		vatUsd = 0,
		shippingUsd = 0,
		discountedUsd = 0,
		paidUsd = 0,
		invoiceNumber = '',
		invoiceUrl = '',
		status = 'new',
		createdAt = '',
		deletedAt = '',
		deletedBy = '',
		updatedAt = '',
		updatedBy = '',
		preparedAt = '',
		refundedBy = '',
		refundedAt = '',
		detailList = [],
	} = {}) {
		this.id = id === null ? '' : id
		this.seasonId = seasonId === null ? '' : seasonId
		this.customerId = customerId === null ? '' : customerId
		this.customerEmail = customerEmail === null ? '' : customerEmail
		this.couponId = couponId === null ? '' : couponId
		this.couponCode = couponCode === null ? '' : couponCode
		this.couponDiscountUsd = couponDiscountUsd === null ? 0 : couponDiscountUsd
		this.boxType = boxType === null ? '' : boxType
		this.deliveryCompany = deliveryCompany === null ? '' : deliveryCompany
		this.trackingNumber = trackingNumber === null ? '' : trackingNumber
		this.shippingRateType = shippingRateType === null ? '' : shippingRateType
		this.deliveryCompletedAt = deliveryCompletedAt === null ? '' : deliveryCompletedAt
		this.receiverGivenName = receiverGivenName === null ? '' : receiverGivenName
		this.receiverFamilyName = receiverFamilyName === null ? '' : receiverFamilyName
		this.phoneCountryNumber = phoneCountryNumber === null ? '' : phoneCountryNumber
		this.phoneNumber = phoneNumber === null ? '' : phoneNumber
		this.address1 = address1 === null ? '' : address1
		this.address2 = address2 === null ? '' : address2
		this.city = city === null ? '' : city
		this.state = state === null ? '' : state
		this.stateIsoCode = stateIsoCode === null ? '' : stateIsoCode
		this.state = state === null ? '' : state
		this.zip = zip === null ? '' : zip
		this.country = country === null ? '' : country
		this.countryCode = countryCode === null ? '' : countryCode
		this.totalUsd = totalUsd === null ? 0 : totalUsd
		this.vatUsd = vatUsd === null ? 0 : vatUsd
		this.shippingUsd = shippingUsd === null ? 0 : shippingUsd
		this.discountedUsd = discountedUsd === null ? 0 : discountedUsd
		this.paidUsd = paidUsd === null ? 0 : paidUsd
		this.invoiceNumber = invoiceNumber === '' ? '' : invoiceNumber
		this.invoiceUrl = invoiceUrl === '' ? '' : invoiceUrl
		this.status = status === null ? 'new' : status
		this.createdAt = createdAt === null ? '' : createdAt
		this.deletedAt = deletedAt === null ? '' : deletedAt
		this.deletedBy = deletedBy === null ? '' : deletedBy
		this.updatedAt = updatedAt === null ? '' : updatedAt
		this.updatedBy = updatedBy === null ? '' : updatedBy
		this.preparedAt = preparedAt === null ? '' : preparedAt
		this.refundedBy = refundedBy === null ? '' : refundedBy
		this.refundedAt = refundedAt === null ? '' : refundedAt
		this.detailList = detailList.map(aDetail => new OrderDetail(aDetail))
	}
	id: string
	seasonId: string
	customerId: string
	customerEmail: string
	couponId: string
	couponCode: string
	couponDiscountUsd: number
	boxType: string
	deliveryCompany: string
	trackingNumber: string
	shippingRateType: string
	deliveryCompletedAt: string
	receiverGivenName: string
	receiverFamilyName: string
	phoneCountryNumber: string
	phoneNumber: string
	address1: string
	address2: string
	city: string
	state: string
	stateIsoCode: string
	zip: string
	country: string
	countryCode: string
	totalUsd: number
	vatUsd: number
	shippingUsd: number
	discountedUsd: number
	paidUsd: number
	invoiceNumber: string
	invoiceUrl: string
	status: string // new | preparing | inTransit | completed | deleted | refunded
	createdAt: string
	deletedAt: string
	deletedBy: string
	updatedAt: string
	updatedBy: string
	preparedAt: string
	refundedBy: string
	refundedAt: string
	detailList: OrderDetailType[]
}

export { Order }
